<template>
  <div style="transition: 0.4s; width: 360px; z-index: 200;" class="flex-1 bg-white rounded-xl space-y-6 p-6 tip-block notify-step">
    <div class="flex items-center mb-2">
      <span class="inline-block w-3 h-3 rounded-full bg-green-500 mr-2"></span>
      <span class="font-bold text-lg">Autoturn Notify</span>
    </div>
    <p v-if="selectLang == 'zh-TW'" class="text-sm text-gray-600">點擊右下角的綠色按鈕，即可綁定 Autoturn Notify，即時接收廣告成效變化與平台通知，重要訊息不漏接。</p>
    <p v-if="selectLang == 'zh-CN'" class="text-sm text-gray-600">点击右下角的绿色按钮，即可绑定 Autoturn Notify，即时接收广告成效变化与平台通知，重要讯息不漏接。</p>
    <p v-if="selectLang == 'en-US'" class="text-sm text-gray-600">Click the green button in the bottom-right corner to set up Autoturn Notify and receive real-time ad performance updates and platform notifications.</p>
    <div class="tip-footer">
      <button
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400 float-right"
        @click="next()"
      >
        {{nextText}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifyMask',
  props: {
    nowStep: {
      type: Number,
      default: 0
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      closeTipsText: '跳過教學'
    }
  },
  watch: {
    selectLang(v) {
      if (v == 'zh-CN') {
        this.nextText = '下一步';
        this.closeTipsText = '跳过教学';
      }
      if (v == 'en-US') {
        this.nextText = 'Next';
        this.closeTipsText = 'Skip the tutorial';
      }
      if (v == 'zh-TW') {
        this.nextText = '下一步';
        this.closeTipsText = '跳過教學';
      }
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
    },
    closeTips() {
      this.$emit('closeTips', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.notify-step {
  position: fixed;
  bottom: 100px;
  right: 100px;
}

.tip-footer {
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
